import Title2 from "./title2";
import MainEssentials from "./mainEssentials";

export default function Enssentials() {
  return (
    <div>
      <Title2 title="Essentials" />
      <MainEssentials />
    </div>
  );
}
